import type { SanityImageField } from "./types"

/**
 * Display `width` / `height` for a resized Sanity image URL when intrinsic dimensions exist.
 * Returns null if metadata is missing (caller may use a fixed fallback aspect).
 */
export function display_dimensions_for_image_width(
  image: SanityImageField | null | undefined,
  requested_width_px: number
): { width: number; height: number } | null {
  const iw = image?.dimensions?.width
  const ih = image?.dimensions?.height
  if (!iw || !ih) {
    return null
  }
  return {
    width: requested_width_px,
    height: Math.max(1, Math.round((requested_width_px * ih) / iw)),
  }
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("display_dimensions_for_image_width", () => {
    it("scales height from intrinsic aspect ratio", () => {
      const dims = display_dimensions_for_image_width(
        { dimensions: { width: 1720, height: 1078 } },
        1400
      )
      expect(dims).toEqual({ width: 1400, height: 877 })
    })

    it("returns null without dimensions", () => {
      expect(display_dimensions_for_image_width({}, 1200)).toBeNull()
    })
  })
}
